// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__9i-Q4","topBottomGutter":"Layout_topBottomGutter__2LHNB"};